// Pure helpers for product dimensions (ProductAdd + ProductDetail), same rules as caseForm:
// the unit only says what the entered numbers mean, switching it never rewrites them.
import { pickUnitOption, toUnitOption } from './caseForm';
import type { ProductDimensionsFormData, ProductDimensionSide, ProductMeasurements, UnitOption } from './types';

export const PRODUCT_DIMENSION_SIDES: ProductDimensionSide[] = ['length', 'width', 'height'];

export const EMPTY_PRODUCT_DIMENSIONS: ProductDimensionsFormData = {
  length: '',
  width: '',
  height: '',
  dimension_unit_option: null,
};

/** Default unit for new products and products saved without one: cm, else the default unit from Settings. */
export const defaultDimensionUnit = (dimensionUnits: unknown): UnitOption | null => pickUnitOption(dimensionUnits, 'cm');

/** Dimension part of the edit form for an existing product. */
export const productDimensionsForm = (product: ProductMeasurements): ProductDimensionsFormData => ({
  ...Object.fromEntries(
    PRODUCT_DIMENSION_SIDES.map((side) => [side, product[side] === null || product[side] === undefined ? '' : String(product[side])]),
  ) as Pick<ProductDimensionsFormData, ProductDimensionSide>,
  dimension_unit_option: toUnitOption(product.dimension_unit, product.dimension_unit_symbol),
});

const parseDimension = (value: string): number | null => {
  if (value === '') return null;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

/** Dimension part of the POST/PATCH payload for products. */
export const buildProductDimensionsPayload = (form: ProductDimensionsFormData) => ({
  ...Object.fromEntries(PRODUCT_DIMENSION_SIDES.map((side) => [side, parseDimension(form[side])])),
  dimension_unit: form.dimension_unit_option?.value ?? null,
});
